import { createWithEqualityFn as create } from 'zustand/traditional';

type CollapsibleCardType = 'link' | 'email' | 'manual';

interface CampaignAddMemberCollapsibleStore {
    collapsibleCard: CollapsibleCardType;
    setCollapsibleCard: (value: CollapsibleCardType) => void;
}

const useAddMemberCollapsibleStore = create<CampaignAddMemberCollapsibleStore>(set => ({
    collapsibleCard: 'link',
    setCollapsibleCard: collapsibleCard => set({ collapsibleCard }),
}));

export { useAddMemberCollapsibleStore };
export type { CampaignAddMemberCollapsibleStore };
